export enum PropertyUnitIntendedUse {
  RESIDENTIAL = 'RESIDENTIAL',
  COMMERCIAL = 'COMMERCIAL',
  LAND = 'LAND',
  WAREHOUSE = 'WAREHOUSE',
  SHELTER = 'SHELTER',
}
